import './SigninPayment.css'
import * as React from 'react';
import { Box, TextField } from "@mui/material";
import pixcode from "@/assets/pixcode.png"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from "react-router-dom";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

function SigninPayment() {
  const navigate = useNavigate();
  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [parcelas, setParcelas] = React.useState('');

  const handleChangeSelect = (event: SelectChangeEvent) => {
    setParcelas(event.target.value as string);
  };

  return(
    <div className="background">
    <div>
      <button className="bg-white rounded-lg p-2 py-3 self-start m-10"
        onClick={(e) => {
          e.preventDefault();
          navigate("/");
        } }><ArrowBackIosIcon sx={{ marginLeft: '8px' }} /></button>
    </div>

    <div className="header-bg">
    <div className="flex flex-col items-center justify-center">
      <h1 className="text-[#490F70] text-center uppercase font-extrabold text-2xl m-auto">Escolha o Pagamento</h1>


      <Box className="flex flex-col justify-center items-center my-5" sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ border: 1, borderRadius: '0.5em', borderColor: '#CB88F9', backgroundColor: 'white' }}>
          <TabList onChange={handleChange} aria-label="forma-pagamento">
            <Tab label="Crédito" value="1" />
            <Tab label="Débito" value="2" />
            <Tab label="Pagamento via Pix" value="3" />
          </TabList>
        </Box>

        <TabPanel value="1">

        <div className="flex flex-col md:flex-row justify-between items-center md:w-[700px] lg:w-[900px]">

        <div className='bg-[#fafafa] border border-[color:--secondary-color] rounded-lg flex flex-col justify-between items-start w-[110%] md:w-80 h-96 py-6 px-10 font-bold my-6'>
        <h2 >Resumo do Pagamento</h2>

        <div>
        {/* PLACEHOLDER */}
        </div>

        <p>Total: <span className="text-[color:--secondary-color]">R$400,00</span></p>
        </div>

        <Box className="w-80 my-5 m-auto grid my-1 gap-6"
        component="form"
        noValidate
        autoComplete="off">

      <div className="row-start-1 col-span-2">
        <label className="text-lg font-bold text-[#490F70]" htmlFor="filled-basic1">
          Número do Cartão
        </label>
        <TextField className="bg-[#f5f5f5] rounded-lg w-80 lg:w-96" id="filled-basic1" variant="filled" placeholder="XXXX XXXX XXXX XXXX" />
      </div>

      <div className="row-start-2 col-start-1 flex flex-col">
        <label className="text-lg font-bold text-[#490F70]" htmlFor="filled-basic2">
          Data de Vencimento
        </label>
        <TextField className="bg-[#f5f5f5] rounded-lg w-48 lg:w-64" id="filled-basic2" variant="filled" placeholder="--/--" />
      </div>


      <div className="row-start-2 col-start-2 flex flex-col">
        <label className="text-lg font-bold text-[#490F70]" htmlFor="filled-basic3">
          CVV
        </label>
        <TextField className="bg-[#f5f5f5] rounded-lg w-24" id="filled-basic3" variant="filled" placeholder="____" />
      </div>

    <div className="flex flex-col col-span-2">
      <label className="text-lg font-bold text-[#490F70]" htmlFor="demo-simple-select">
         Parcelas
        </label>
        <Select
        className="w-80 lg:w-96"
        sx={{ backgroundColor: '#f5f5f5' }}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={parcelas}
          label="x1"
          onChange={handleChangeSelect}
        >
          <MenuItem value={10}>x1</MenuItem>
          <MenuItem value={20}>x2</MenuItem>
          <MenuItem value={30}>x3</MenuItem>
          <MenuItem value={40}>x4</MenuItem>
          <MenuItem value={50}>x5</MenuItem>
          <MenuItem value={60}>x6</MenuItem>
          <MenuItem value={70}>x7</MenuItem>
          <MenuItem value={80}>x8</MenuItem>
          <MenuItem value={90}>x9</MenuItem>
          <MenuItem value={100}>x10</MenuItem>

        </Select>
      </div>


        </Box>



        </div>
        </TabPanel>

        <TabPanel value="2">

        <div className="flex flex-col md:flex-row justify-between items-center md:w-[700px] lg:w-[900px]">

        <div className='bg-[#fafafa] border border-[color:--secondary-color] rounded-lg flex flex-col justify-between items-start w-[110%] md:w-80 h-96 py-6 px-10 font-bold my-6'>
        <h2 >Resumo do Pagamento</h2>

        <div>
        {/* PLACEHOLDER */}
        </div>

        <p>Total: <span className="text-[color:--secondary-color]">R$400,00</span></p>
        </div>

        <Box className="w-80 my-5 m-auto grid justify-center my-1 gap-6"
        component="form"
        noValidate
        autoComplete="off">

      <div className="row-start-1 col-span-2">
        <label className="text-lg font-bold text-[#490F70]" htmlFor="filled-basic1">
          Número do Cartão
        </label>
        <TextField className="bg-[#F5F5F5] rounded-lg w-80 lg:w-96" id="filled-basic1" variant="filled" placeholder="XXXX XXXX XXXX XXXX" />
      </div>

      <div className="row-start-2 flex flex-col">
        <label className="text-lg font-bold text-[#490F70]" htmlFor="filled-basic2">
          Data de Vencimento
        </label>
        <TextField className="bg-[#F5F5F5] rounded-lg w-48" id="filled-basic2" variant="filled" placeholder="--/--" />
      </div>


      <div className="row-start-2 col-start-2 flex flex-col">
        <label className="text-lg font-bold text-[#490F70]" htmlFor="filled-basic3">
          CVV
        </label>
        <TextField className="bg-[#F5F5F5] rounded-lg w-24" id="filled-basic3" variant="filled" placeholder="____" />
      </div>


        </Box>

        </div>
        </TabPanel>

        <TabPanel value="3">

        <div className="flex flex-col md:flex-row justify-between items-center md:w-[700px] md:items-start">

        <div className='bg-[#fafafa] border border-[color:--secondary-color] rounded-lg flex flex-col justify-between items-start w-[110%] md:w-80 h-96 py-6 px-10 font-bold my-6'>
        <h2 >Resumo do Pagamento</h2>

        <div>
        {/* PLACEHOLDER */}
        </div>

        <p>Total: <span className="text-[color:--secondary-color]">R$400,00</span></p>
        </div>

        <div className="w-80 my-5 text-center">
        <h2 className="text-xl font-bold">Aguardando Pagamento</h2>
        <p className="text-[#490F70] my-2 text-sm">Copie o código abaixo para pagar via Pix em qualquer aplicativo habilitado:</p>

        <img className="w-40 m-auto my-6" src={pixcode} alt="" />

        <p className="text-[#8D92A3] my-2 text-sm">Você tem até 5 minutos para fazer o pagamento. Após esse tempo, o pedido será cancelado.</p>

        <div className="bg-white border-2 border-[#490F70] text-[color:--secondary-color] w-64 m-auto p-3 rounded-lg font-medium">0002010102122677...<button className="pl-3"><ContentCopyIcon /></button></div>

        <button
          className="bg-[color:--secondary-color] text-white col-span-2 font-semibold rounded-lg py-3 my-2 m-auto w-64 hover:bg-[color:--secondary-color]/90 active:bg-[#]/80" onClick={(e) => {
            e.preventDefault();
            navigate("/signin/contract");
          }}>
          Copiar código
        </button>

        </div>
        </div>
        </TabPanel>
      </TabContext>


    </Box>

    <button
          className="bg-[#490F70] text-white col-span-2 font-semibold rounded-lg py-3 my-2 w-64 m-auto hover:bg-[#490F70]/90 active:bg-[#490F70]/80" onClick={(e) => {
            e.preventDefault();
            navigate("/signin/contract");
          }}>
          Continuar
        </button>

      </div>
    </div><div className='footer-bg'></div>
    </div>

  )
}

export default SigninPayment;